import { IconName } from '@optimus-web/icons';
import { IconButton } from '@optimus-web/core';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { useUpdateGoLiveDate } from './useUpdateGoLiveDate';

export const GoLiveDatePicker = () => {
    const [renderUpdateGoLiveDateDialog, toggleUpdateGoLiveDateDialog] = useUpdateGoLiveDate();
    const onboardingAuditEditGoLiveDateEnabled = useFeatureFlag(FeatureFlag.onboardingAuditEditGoLiveDateEnabled);

    if (!onboardingAuditEditGoLiveDateEnabled) return null;

    return (
        <>
            <IconButton icon={IconName.Edit} type="button" size="small" onClick={toggleUpdateGoLiveDateDialog} />
            {renderUpdateGoLiveDateDialog()}
        </>
    );
};
